import React from "react";
import { CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { HeartPulse, LogOut, User, Menu, MessageCircle, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { authService } from "@/services/auth.service";
import { toast } from "sonner";
import { FeedbackButton } from "@/components/FeedbackButton";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const DashboardHeader = () => {
  const navigate = useNavigate();

  const handleProfileNavigation = () => {
    navigate("/profile");
  };

  const handleLogout = async () => {
    try {
      const {
        success
      } = await authService.signOut();
      
      if (success) {
        // Clear isAdmin flag from localStorage to ensure clean logout
        localStorage.removeItem('isAdmin');
        toast.success("Logged out successfully");
        navigate('/auth');
      } else {
        toast.error("Failed to log out");
        navigate('/auth');
      }
    } catch (error) {
      console.error("Error logging out:", error);
      toast.error("Logout failed. Please try again.");
      navigate('/auth');
    }
  };

  return (
    <CardHeader className="pb-2 border-b border-[#CCCCCC]">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <HeartPulse className="h-6 w-6 text-[#3BAFDA]" />
          <div>
            <CardTitle className="text-xl text-[#333B44]">Therapist Dashboard</CardTitle>
            <CardDescription>Manage your client connections and view journal entries</CardDescription>
          </div>
        </div>
        {/* Desktop: show all buttons */}
        <div className="hidden sm:flex items-center gap-2">
          <Button 
            variant="outline" 
            size="sm" 
            className="border-[#CCCCCC] hover:bg-[#E8F0F8]" 
            onClick={handleProfileNavigation}
          >
            <User className="h-4 w-4 mr-1" />
            My Profile
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            className="border-[#CCCCCC] hover:bg-[#E8F0F8]"
            onClick={() => navigate('/therapists')}
          >
            <Users className="h-4 w-4 mr-1" />
            Therapist Directory
          </Button>
          <FeedbackButton />
          <Button 
            variant="outline" 
            size="sm" 
            className="border-[#CCCCCC] hover:bg-[#E8F0F8]" 
            onClick={handleLogout}
          >
            <LogOut className="h-4 w-4 mr-1" />
            Logout
          </Button>
        </div>
        {/* Mobile: show hamburger menu */}
        <div className="sm:hidden">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="icon" className="border-[#CCCCCC]">
                <Menu className="h-6 w-6" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={handleProfileNavigation}>
                <User className="h-4 w-4 mr-2" /> My Profile
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => navigate('/therapists')}>
                <Users className="h-4 w-4 mr-2" /> Therapist Directory
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <FeedbackButton />
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleLogout}>
                <LogOut className="h-4 w-4 mr-2" /> Logout
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </CardHeader>
  );
};

export default DashboardHeader;
